import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { Header } from './Header';
import { TermsGatekeeper } from '@/components/gatekeeper/TermsGatekeeper';
import { MobileSidebar } from './MobileSidebar';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import { WebPushPrompt } from './WebPushPrompt';
import { SidebarProvider } from '@/contexts/SidebarContext';

export const AppLayout = () => {
  return (
    <TermsGatekeeper>
      <SidebarProvider>
        <div className="flex h-screen overflow-hidden bg-background">
          <AppSidebar />
          <div className="flex flex-1 flex-col overflow-hidden min-w-0">
            <Header />
            <WebPushPrompt />
            <main className="flex-1 overflow-y-auto">
              <div className="container py-6">
                <ErrorBoundary nivel="page">
                  <Outlet />
                </ErrorBoundary>
              </div>
            </main>
          </div>
          {/* Mobile sidebar drawer — rendered as Sheet overlay */}
          <MobileSidebar />
        </div>
      </SidebarProvider>
    </TermsGatekeeper>
  );
};
